/**
 * Created by andrey on 28.05.2021.
 */

const Version = {
    compare: function (a, b) {
        if (!a || !b) {
            return !!a - !!b;
        }

        const arrayA = a.split(".");
        const arrayB = b.split(".");

        for (let i = 0; i < Math.min(arrayA.length, arrayB.length); i++) {
            const v1 = parseInt(arrayA[i]);
            const v2 = parseInt(arrayB[i]);
            if (v1 !== v2) {
                return v1 - v2;
            }
        }

        return arrayA.length - arrayB.length;
    },

    isVersion: function (version) {
        if (typeof version !== "string") {
            return false;
        }
        const parts = version.split(".");
        return parts.length === 3 && parts.every((part) => /^\d+$/.test(part));
    },

    isMinorEquals: function (v1, v2) {
        return v1.split(".").slice(0, 2).join(".") === v2.split(".").slice(0, 2).join(".");
    },

    incPatch: function (version) {
        const parts = version.split(".");
        parts[2] = +parts[2] + 1;
        return parts.join(".");
    },

    incMinor: function (version) {
        const parts = version.split(".");
        parts[1] = +parts[1] + 1;
        parts[2] = 0;
        return parts.join(".");
    },

    incMajor: function (version) {
        const parts = version.split(".");
        parts[0] = +parts[0] + 1;
        parts[1] = 0;
        parts[2] = 0;
        return parts.join(".");
    },

    getMajor: function (version) {
        return +(version.split(".")[0]);
    },

    getMinor: function (version) {
        return +(version.split(".")[1]);
    },

    getPatch: function (version) {
        return +(version.split(".")[2]);
    },

    inc: function (version, updateType) {
        if (updateType === "major") {
            return this.incMajor(version);
        }
        if (updateType === "minor") {
            return this.incMinor(version);
        }
        if (updateType === "patch") {
            return this.incPatch(version);
        } 
        throw "updateType must be major, minor or patch";
    }
};

if (typeof cc === "undefined") {
    module.exports = Version;
}
